














import Vue from 'vue'
import activeTableTree from '@/components/Ui/ActiveTableTree/ActiveTableTree.vue'
import tableTreeConfig from '@/activeTableTrees/wiki/list'
import {setSessStoreItem, getSessStoreItem} from '@/services/sessionStorageTransfer'
import WikiNode from '@/models/wiki/wikiNode'
import {PROJ_PFX} from '@/constants'
const sessStorExpandedState = `${PROJ_PFX}wikiTree_expanded_state`
export default Vue.extend({
  name: 'wikiTree',
  components: {
    activeTableTree
  },
  data () {
    return {
      tableTreeConfig,
      tree: [],
      defaultExpandedKeys: [] as string[],
      expandedKeys: [] as string[],
    }
  },
  methods: {
    async getWikiTree (): Promise<void> {
      try {
        let list = await this.$store.dispatch('wiki/getNodesTree')
        this.tree = list;
        console.log('LOG: getWikiTree -> list', list)
      } catch (error) {
        console.error('LOG: getWikiTree -> error', error)
      }
    },
    onActionsError (error: any): void {
      console.log('TableTree Actions Error', error)
      if (error.data.error.message && error.data.error.message === 'children nodes exist' || error.data.error.message === 'children pages exist') {
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('labels.node_has_children'),
          type: 'warning'
        });
      }
    },
    onNodeExpand (event: WikiNode) {
      const key = event.id
      if (this.expandedKeys.indexOf(key) < 0) {
        this.expandedKeys.push(key)
      }
      this.saveExpandedKeys()
    },
    onNodeCollapse (event: WikiNode) {
      const index = this.expandedKeys.indexOf(event.id)
      if (index >= 0) {
        this.expandedKeys.splice(index, 1);
      }
      this.saveExpandedKeys()
    },
    saveExpandedKeys () {
      setSessStoreItem(sessStorExpandedState, this.expandedKeys)
    },
    getExpandedKeys () {
      return getSessStoreItem(sessStorExpandedState)
    },
    setDefaultExpandedKeys () {
      const state = this.getExpandedKeys()
      if (state) {
        this.defaultExpandedKeys = state
      }
    }
  },
  async mounted () {
    this.setDefaultExpandedKeys()
    await this.getWikiTree()
  }
})
